import React from 'react';
import { maxSizeDesktop } from 'helpers/style';
import { TextSmall, Text } from '../../common/text';
import styled from '@emotion/styled';

const Wrapper = styled.div`
    width: 100%;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const OrangeText = styled(Text)`
    color: ${(p) => p.theme.color.orange};
    line-height: 16px;
`;

const OrangeTextSmall = styled(TextSmall)`
    color: ${(p) => p.theme.color.orange};
    line-height: 30px;
    ${maxSizeDesktop} {
        line-height: 26px;
    }
`;

const TextEmptyDataset = styled(Text)`
    line-height: 16px;
`;

export const NO_DATA_TEXT = '(Data Unavailable)';
export const NoDataText = () => <OrangeText>{NO_DATA_TEXT}</OrangeText>;
export const NoDataTextSmall = () => <OrangeTextSmall>{NO_DATA_TEXT}</OrangeTextSmall>;

export const NoData = React.memo(({ message }) => {
    return <Wrapper>{message ? <TextEmptyDataset>{message}</TextEmptyDataset> : <NoDataText />}</Wrapper>;
});
